import './index.css';
import { useCallback } from 'react';

const useDropActions = ({ onDropAccepted: onDropAcceptedExternal, onDropRejected: onDropRejectedExternal, onFileDelete: onFileDeleteExternal, }) => {
    const onDropAccepted = useCallback((acceptedFiles, event) => {
        const acceptedLoadFiles = acceptedFiles.map((file) => ({ data: file, loading: true, loadPercentage: 0 }));
        onDropAcceptedExternal(acceptedLoadFiles, event);
    }, [onDropAcceptedExternal]);
    const onDropRejected = useCallback((fileRejections, event) => {
        const rejectionLoadFiles = fileRejections.map((fileRejection) => ({
            data: fileRejection.file,
            loading: false,
            error: fileRejection.errors?.[0].code || '',
        }));
        onDropRejectedExternal?.(rejectionLoadFiles, event);
    }, [onDropRejectedExternal]);
    const onFileDelete = useCallback((event, loadedFile, indexFile) => {
        loadedFile && onFileDeleteExternal(loadedFile, indexFile);
        event.stopPropagation();
    }, [onFileDeleteExternal]);
    return { onDropAccepted, onDropRejected, onFileDelete };
};

export { useDropActions };
//# sourceMappingURL=useDropActions.js.map
